export const buildInfo = {
    buildDate: "Tue, 06/10/2026",
    buildTime: "16:18:13",

    sourceTag: "release-2026R8",
    sourceDate: "Tue, 6 Oct 2026 08:25:56 +0800",
    sourceBranch: "master",
    sourceHash: "1d05561d1b3521fbaf7f4b0abd6d8ad9aef1f931",
};
